module.exports = __webpack_public_path__ + "img/dimensoes_logo.440229af.png";